interface SearchableOption {
  label: string
  displayLabel?: string
  keywords?: string[]
  sublabel?: string
  hint?: string
}

/** Normalização compartilhada pela busca local, cache remoto e testes. */
export function normalizeSearchText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase()
    .trim()
    .replace(/\s+/g, ' ')
}

export function optionMatches(option: SearchableOption, rawQuery: string): boolean {
  const query = normalizeSearchText(rawQuery)
  if (!query) return true
  const searchable = [option.label, option.displayLabel, option.sublabel, option.hint, ...(option.keywords ?? [])]
    .filter(Boolean)
    .join(' ')
  return normalizeSearchText(searchable).includes(query)
}
